export const Accessories: React.FC<React.SVGAttributes<{}>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" {...props}>
      <g fill="currentColor">
        <path
          data-name="Path 21759"
          d="M16.546 6.908H1.455A1.456 1.456 0 000 8.362v8.187a1.456 1.456 0 001.455 1.454h15.091A1.456 1.456 0 0018 16.549V8.366a1.456 1.456 0 00-1.454-1.458zm.727 9.638a.728.728 0 01-.727.727H1.455a.728.728 0 01-.727-.727V8.363a.728.728 0 01.727-.727h15.091a.728.728 0 01.727.727z"
        />
        <path
          data-name="Path 21760"
          d="M15.818 8.726H2.182a.364.364 0 00-.364.364v6.729a.364.364 0 00.364.364h13.636a.364.364 0 00.364-.364V9.09a.364.364 0 00-.364-.364zm-.364 3.365h-3.818V9.454h3.818zm-8.364 0V9.454h3.821v2.637zm3.818.727v2.637H7.091v-2.637zM6.363 9.453v2.637H2.545V9.453zm-3.818 3.365h3.818v2.637H2.545zm9.091 2.637v-2.637h3.818v2.637z"
        />
        <path
          data-name="Path 21761"
          d="M3.875 3.273A3.847 3.847 0 006.46 2h5.081a3.847 3.847 0 002.585 1.273 1.637 1.637 0 000-3.273 3.847 3.847 0 00-2.585 1.273H6.46A3.847 3.847 0 003.875 0a1.637 1.637 0 100 3.273zM14.125.728a.909.909 0 110 1.818 1.175 1.175 0 110-1.818zm-10.25 0a1.175 1.175 0 110 1.818.909.909 0 110-1.818z"
        />
      </g>
    </svg>
  );
};
